// Generate a random number between two values.
// Uses the web Crypto interface for better randomization.
export default function randomNumberBetween(min: number = 0, max: number = 100): number {
  // Create byte array and fill with 1 random number
  var byteArray = new Uint8Array(1);
  window.crypto.getRandomValues(byteArray);

  var range = max - min + 1;
  var max_range = 256;

  if (byteArray[0] >= Math.floor(max_range / range) * range) {
    return randomNumberBetween(min, max);
  } else {
    return min + (byteArray[0] % range);
  }
}
